export enum ReduceToClearEnum {
  ALL_STATUS = '',
  AWAITING_SCHEDULE = 'awaiting_schedule',
  ACTIVE = 'active',
  SOLD_OUT = 'sold_out',
  EXPIRED = 'expired'
}
